<template>
    <div id="header-inner-bm">
        <div class="search-form d4k-hidden">
            <form method="" id="" action="" target="" autocomplete="">
                <label>
                    <input type="text"class="search-input" autocomplete="off" placeholder=""
                           ref="headerSearchText" v-on:input="inputText()" @click.prevent="inputText()">
                </label>
                <button title="검색" class="search-btn" @click.prevent="inputText()"><i class="search-icon"></i></button>
            </form>
        </div>
        <!-- 검색결과 -->
        <div class="search-list" v-show="searchList.length > 0">
            <ul class="scroll9">
                <li v-for="search in searchList">
                    <span style="cursor: pointer;" @click.prevent="movePage(search.val4)">
                        {{ search.val2 }}
                        <span v-if="typeof search.val3 !== $_TYPE.UNDEF && search.val3 !== ''">> {{ search.val3 }}</span>
                    </span>
                </li>
            </ul>
            <div class="btn_close" @click.prevent="searchList = [];">닫기</div>
        </div>

    </div>
</template>

<script>
import commonApi from "@/apis/common.api";
import { $_TYPE, $_WC, $_DKD } from "@/confs/common.const.js";

export default {
    data(){
        return {
            searchList: [],
        };
    },
    computed: {
    },
    methods: {
        inputText(){
            this.searchList = [];
            let searchText = this.$refs.headerSearchText.value;
            if(searchText.length >= 1) {
                let q = 'whereLike=val1::' + encodeURIComponent(searchText) + '&orderBy=basdtVal::desc&searchLimit=10';
                commonApi.fetchRepoDataList($_DKD.SEARCH_KEYWORD, q)
                    .then(res=>{
                        this.searchList = res.data.data;
                    });
            }
        },
        movePage(url){
            location.href = $_WC.cp + '' + url;
        },
    },
};
</script>
<style>
.header-search-list {
    background-color: #ffffff;
    height: auto;
}
</style>
